import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";

// The API
import {
    TrainingSubscription,
} from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    training  : {},
    elem      : {},
    members   : [],
    statuses  : [],
    filters   : {
        search   : "",
        status   : "",
        fromDate : "",
        toDate   : "",
    },
    sort      : {
        orderBy  : "createdTime",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "TRAINING_SUBSCRIPTION_LOADING" });
    },

    /**
     * Fetches the Training Subscription List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, filters = {}, sort = {}) {
        const params = { ...filters, ...sort };
        Navigate.unsetParams(params);
        if (type === "TRAINING") {
            params.trainingID = elemID;
        }

        const data   = await TrainingSubscription.getAll(params);
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "TRAINING_SUBSCRIPTION_LIST", data });
    },

    /**
     * Fetches a single Training Subscription
     * @param {Function} dispatch
     * @param {Number}   subscriptionID
     * @returns {Promise}
     */
    async fetchElem(dispatch, subscriptionID) {
        const data = await TrainingSubscription.getOne({ subscriptionID });
        dispatch({ type : "TRAINING_SUBSCRIPTION_ELEM", data });
    },

    /**
     * Fetches the Training Subscription Edit data
     * @param {Function} dispatch
     * @param {Number}   trainingID
     * @param {Number=}  memberNumber
     * @param {Boolean=} isInitial
     * @returns {Promise}
     */
    async fetchEditData(dispatch, trainingID, memberNumber = 0, isInitial = true) {
        const data = await TrainingSubscription.getEditData({ trainingID, memberNumber });
        data.isInitial = isInitial;
        dispatch({ type : "TRAINING_SUBSCRIPTION_EDIT", data });
    },

    /**
     * Edits/Creates a Training Subscription
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return TrainingSubscription.edit(data);
    },

    /**
     * Deletes a Training Subscription
     * @param {Function} dispatch
     * @param {Number}   subscriptionID
     * @returns {Promise}
     */
    deleteElem(dispatch, subscriptionID) {
        return TrainingSubscription.delete({ subscriptionID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdTimeText  = DateTime.formatString(elem.createdTime, false);
    elem.name             = `${elem.memberNumber} - ${elem.memberName}`;
    elem.relatedName      = `${elem.relatedMemberNumber} - ${elem.relatedMemberName}`;
    elem.subscribedMember = elem.subscriptionType === "Me" ? elem.name : elem.relatedName;
    elem.fileText         = Utils.toYesNo(elem.file ? 1 : 0);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "TRAINING_SUBSCRIPTION_LIST", "TRAINING_SUBSCRIPTION_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "TRAINING_SUBSCRIPTION_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "TRAINING_SUBSCRIPTION_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            training  : action.data.training,
            statuses  : action.data.statuses,
            filters   : action.data.filters,
            sort      : action.data.sort,
        };

    case "TRAINING_SUBSCRIPTION_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            members   : action.data.members,
            statuses  : action.data.statuses,
        };

    case "TRAINING_SUBSCRIPTION_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + (action.data.isInitial ? 1 : 0),
            members   : action.data.members,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
